import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Input, UncontrolledTooltip } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import CikkSelect from '../CikkSelect.jsx';
import _ from 'lodash';
import { DatePicker, DatetimePicker } from '../../../../../commons/controls.js';
import { ProgressButton } from '../../../../../commons/ProgressButton';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import { PaginationTotal } from '../../../../../commons/controls';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Service from '../services.js';
import moment from 'moment';
import Lib from '../../../../../commons/lib';
import NumberFormatter from '../../../../../commons/NumberFormatter';
import RFForm from '../../../../../components/Form/RFForm.js';
import RFField from '../../../../../components/Form/RFField.js';
import SelectField from '../../../../../components/Form/SelectField.js';
import TimeFormatter from '../../../../../commons/TimeFormatter.js';
import getTooltip from '../../../KeszletTooltips.js';
import CustomTooltip from '../../../../../components/Tooltip/CustomTooltip.js';


const STYLE_ROW = {marginTop: '15px'};
class KeszletcsokkenesForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      hasRendelesModule: false,

      modalTorles: false,
      modalCikk: false,
      modalAccept: false,
      modalPartnerFelvitel: false,
      modalRendelesCikk: false,

      rendelesCikkSelected: [],

      formCikkVisszList: [],
      formRaktar: null,
      formPenznem: null,
      formFizmod: null,
      formPartner: null,
      // checkForRendelesModule()-ból kivenni az alapérték állítást, ha más értéket is felvehet a mező/nem szükséges a default
      formFunkcioNev: null,
      formFunkcio: null,
      formMozgasTipus: null,
      formKulsoAzon: null,
      formFizetesihatarido: null,
      formMozgasDatum: new Date(),
      telepulesMezo: [],
      csokkenes: {},
      editobj: {},
      cikkek: [],

      formKeszletInfoRaktarak: [],
      formKeszletLoadingStatus: 'LOAD',
      mentesLoadingButton: false,
      szabadMennyiseg: null,
      
      searchButtonLoading: false,
      addButtonLoading: false,
      modifyButtonLoading: false,
      deleteButtonLoading: false,
      sendButtonLoading: false,
      pdfButtonLoading: false,
    };
    this.selected = false;
    this.raktarAzonosito = 'KESZLET';
  }

  componentWillMount() {
    this.checkForRendelesModule();
    let params = new URL(window.location.href).searchParams;
    let id = params.get('id');
    if (this.props.modositas === 'true') {
      if (id) this.getData(id);
    } else {
      this.setState({
        csokkenes: {}
      });
    }
  }

  modosit = () => {
    this.props.navigate(this.props.globals.public_url.concat('/admin/keszlet/keszletkezeles/keszletcsokkenes/felvetel'));
  }

  handleBackClick = () => {
    this.props.navigate(this.props.globals.public_url.concat('/admin/keszlet/keszletkezeles?page=2'));
  }

  toggle = () => {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  toggleTorles = () => {
    this.setState({ modalTorles: !this.state.modalTorles });
  }

  toggleAccept = () => {
    this.setState({ modalAccept: !this.state.modalAccept });
  }

  toggleRendelesCikk = () => {
    this.setState({ modalRendelesCikk: !this.state.modalRendelesCikk, rendelesCikkSelected: [] });
  }

  toggleCikk = () => {
    this.setState({ modalCikk: !this.state.modalCikk });
  }

  togglePartnerFelvitel = () => {
    this.setState({ modalPartnerFelvitel: !this.state.modalPartnerFelvitel, telepulesMezoInaktiv: true });
  }

  getData = (id) => {
    Service.getCsokkenes(id, (err, res) => {
      if (!err) {
        let csokkenes = {...res[0][0]};
        this.setState({ 
          csokkenes: csokkenes, 
          cikkek: csokkenes.cikkek, 
          formKulsoAzon: csokkenes.kulsoAzon,
          formRaktar: csokkenes.raktar,
          formPartner: csokkenes.partner,
          formMozgasTipus: csokkenes.mozgasTipus,
          formMegjegyzes: csokkenes.megjegyzes,
          formMunkalapszam: csokkenes.munkalapszam,
          formFizetesihatarido: csokkenes.fizetesihatarido,
          formFizmod: csokkenes.fizmod,
          formMozgasDatum: csokkenes.mozgasDatum,
          formFunkcio: csokkenes.funkcioId && { id: csokkenes.funkcioId },
          formFunkcioNev: csokkenes.funkcio && csokkenes.funkcio.name
        }, () => {
          if (this.state.hasRendelesModule && csokkenes.partner) {
            Service.listRendelesCsokkenes(csokkenes.partner.id, csokkenes.funkcioId, (err2, res2) => {
              if (!err2) {
                this.setState({ funkcioOptions: res2[0], formFunkcio: res2[0].find(r => r.id == csokkenes.funkcioId) });
              }
            });
          }
          if (this.isVisszaruMozgTipus() && csokkenes.elozmenyid) {
            Service.getBevetelezes(csokkenes.elozmenyid, (err, res) => {
              if (!err) {
                this.handleVisszaruChange({...res[0][0]}, true);
              }
            });
          }
        });
      }
    });
  }

  checkForRendelesModule = () => {
    Service.checkForRendelesModule((err, res) => {
      if (!err) {
        this.setState({ hasRendelesModule: res[0] == true });
        if (res[0]) {
          this.setState({ formFunkcioNev: 'VEVOI_RENDELES' });
        }
      }
    });
  }

  handleRendelesCikkSubmit = () => {
    const { formFunkcio, rendelesCikkSelected } = this.state;
    const rendelescikkek = formFunkcio.rendelescikkbeans.filter(rc => rendelesCikkSelected.includes(rc.id));
    let cikkekNew = [];
    rendelescikkek.forEach((rc) => {
      cikkekNew.push({ cikk: rc.cikk, mennyiseg: rc.mennyiseg, cikkid: rc.cikk.id, funkciotetelId: rc.id, funkciotetel: 'VEVOI_RENDELES_CIKK' });
    });
    let { cikkek } = this.state;
    cikkek.push(...cikkekNew);
    this.setState({ cikkek, rendelesCikkSelected: [], modalRendelesCikk: false });
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  save = (event, csokkenesObj) => {
    let submitType = document.activeElement.getAttribute('id');
    if (this.state.cikkek && this.state.cikkek.length === 0 && submitType !== 'save-and-close') {
      this.props.globals.addWarning('Nem lett cikk kiválasztva!');
    }

    let submitObj = {};
    submitObj.cikkek = this.state.cikkek.map((c) => { return { ...c, funkciotetel: typeof c.funkciotetel === 'string' ? c.funkciotetel : c.funkciotetel && c.funkciotetel.name, cikkVisszaru: null, selejtezesOka: this.emptyOrNull(c.selejtezesOka) }; });
    submitObj.mozgasDatum = this.state.formMozgasDatum && TimeFormatter.formatIso(this.state.formMozgasDatum);
    submitObj.fizetesihatarido = this.state.formFizetesihatarido && TimeFormatter.formatDate(this.state.formFizetesihatarido);
    submitObj.partnerid = this.state.formPartner && this.state.formPartner.id;
    submitObj.raktarid = this.state.formRaktar && this.state.formRaktar.id;
    submitObj.fizmodId = this.state.formFizmod && this.state.formFizmod.id;
    submitObj.kulsoAzon = this.state.kulsoAzon;
    submitObj.megjegyzes = this.state.formMegjegyzes;
    submitObj.munkalapszam = this.state.formMunkalapszam;
    submitObj.mozgasTipus = this.state.formMozgasTipus && this.state.formMozgasTipus.id;
    if (this.isVisszaruMozgTipus())
      submitObj.elozmenyid = this.state.formElozmenyKeszlet?.id;
    if (this.state.hasRendelesModule && this.state.formFunkcio) {
      submitObj.funkcio = this.state.formFunkcioNev;
      submitObj.funkcioId = this.state.formFunkcio && this.state.formFunkcio.id;
    }

    if (submitType === 'save-and-close' && !this.state.modalAccept) {
      this._currentAcceptObj = csokkenesObj;
      this.toggleAccept();
      return;
    } else if (submitType === 'save-and-close' && this.state.modalAccept) {
      this.toggleAccept();
    }

    if (this.state.csokkenes && this.state.csokkenes.id) {
      this.editKeszlet(submitObj); 
    } else {
      this.addKeszlet(submitObj); 
    }
  }

  addKeszlet(csokkenesObj) {
    let submitType = document.activeElement.getAttribute('id');

    if (submitType === 'save-and-close') {
      this.setState({mentesLoadingButton: true}, () => {
        Service.acceptAddCsokkenes(csokkenesObj, (err, res) => {
          if (!err) {
            this.props.globals.addSuccess('Készletcsökkenési tétel véglegesítve!');
            this.props.navigate(this.props.globals.public_url.concat('/admin/keszlet/keszletkezeles?page=2'));
            this.setState({mentesLoadingButton: false});
          }else{
            this.setState({mentesLoadingButton: false});
          }
        });
      });
      
    } else {
      this.setState({mentesLoadingButton: true}, () => {
        Service.addCsokkenes(csokkenesObj, (err, res) => {
          if (!err) {
            this.props.globals.addSuccess('Készletcsökkenési tétel hozzáadva!');
            this.props.navigate(this.props.globals.public_url.concat('/admin/keszlet/keszletkezeles?page=2'));
            this.setState({mentesLoadingButton: false});
          }else{
            this.setState({mentesLoadingButton: false});
          }
        });
      });
    }
  }

  editKeszlet(csokkenesObj) {
    let submitType = document.activeElement.getAttribute('id');

    csokkenesObj.id = this.state.csokkenes.id;
    if (submitType === 'save-and-close') {
      this.setState({mentesLoadingButton: true}, () => {
        Service.acceptEditCsokkenes(csokkenesObj, this.state.csokkenes.id, (err, res) => {
          if (!err) {
            this.props.globals.addSuccess('Készletcsökkenési tétel módosítva és véglegesítve!');
            this.props.navigate(this.props.globals.public_url.concat('/admin/keszlet/keszletkezeles?page=2'));
            this.setState({mentesLoadingButton: false});
          }else{
            this.setState({mentesLoadingButton: false});
          }
        });
      });
    } else {
      this.setState({mentesLoadingButton: true}, () => {
        Service.editCsokkenes(csokkenesObj, this.state.csokkenes.id, (err, res) => {
          if (!err) {
            this.props.globals.addSuccess('Készletcsökkenési tétel módosítva!');
            this.props.navigate(this.props.globals.public_url.concat('/admin/keszlet/keszletkezeles?page=2'));
            this.setState({mentesLoadingButton: false});
          }else{
            this.setState({mentesLoadingButton: false});
          }
        });
      });
    }
  }

  loadMozgasTipusOptions = (input, callback) => {
    Service.listMozgastipusCsokkenes((err, res) => {
      if (!err) {
        let options = [];
        res[0]
          .filter(m => m.name.toLowerCase().includes(input.toLowerCase()))
          .filter(m => !m.id.includes("LELTAR"))
          .forEach((item) => {
            options.push(item);
          });
        callback(options);
      }
    });
  }

  loadVisszaruBevetelezes = (input, callback) => {
    if (input) {
      let filter = {
        bizonylatszam: input,
        mozgasTipusList: ['BEV'],
        allapot: 'NORMAL'
      };
      Service.listBevetelezes(filter, (err, res) => {
        if (!err) {
          callback(res[0]);
        }
      });
    }
  }

  loadFizmodOptions = (input, callback) => {
    Service.listAktivFizetesimod((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter(k => k.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  loadRaktarOptions = (input, callback) => {
    Service.listBizonylatRaktar(this.raktarAzonosito, null, null, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter(k => k.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);

        if(!this.isVisszaruMozgTipus() && !input && !this.state.formRaktar && options.length > 0) {
          this.setState({ formRaktar: options[0] });
        }
      }
    });
  }

  loadPartnerOptions = (text, callback) => {
    let newArray = [];
    if (text && text.length === 0) {
      callback(newArray);
      return;
    } 
    Service.queryPartner('KESZLET_VEVO_FORM', text, (err, res) => {
      if (!err) {
        res[0].forEach(item => {
          newArray.push(item);
        });
        callback(newArray);
      }
    });
  }

  loadKeszletInfo = () => {
    const { formRaktar, } = this.state;
    this.setState({ formKeszletLoadingStatus: 'LOAD' }, () => {
      Service.getRaktarList([this.state.selectedCikkId], formRaktar && formRaktar.id ? [formRaktar.id] : [], (err, res) => {
        if (!err) {
          this.setState({
            formKeszletInfoRaktarak: res[0],
            formKeszletLoadingStatus: 'DATA',
          });
        } else {
          this.setState({
            formKeszletInfoRaktarak: [],
            formKeszletLoadingStatus: 'NETW'
          });
        }
      });
    });
  }
  
  handleNewCikkClick = (id) => {
    this.setState({ editmode: false, editobj: undefined }, () => {
      this.toggleCikk();
    });
  }

  handleEditCikkClick = (id, row) => {
    this.setState({ editmode: true, editobj: row, selectedCikkId: id }, () => {
      this.toggleCikk();
    });
  }

  handleDeleteCikkClick = (cikkobj) => {
    this._currentDeleteObj = cikkobj;
    this.toggleTorles();
  }

  handleListItemClick = (raktarId) => {
    let newRaktarak = [];
    const raktarak = JSON.parse(JSON.stringify(this.state.formKeszletInfoRaktarak));
    raktarak.forEach((item) => {
      item.raktar.selected = item.raktarId === raktarId;
      newRaktarak.push(item);
    });
    this.setState({ formKeszletInfoRaktarak: newRaktarak });
  }

  onSaveKeszletInfo = (raktarId, szabadMennyiseg, raktarNev) => {
    this.setState({ szabadMennyiseg: szabadMennyiseg, formRaktar: { id: raktarId, nev: raktarNev } });
  }

  addRendelesFunkcioTetelId = (cikkObj) => {
    if (this.state.hasRendelesModule && this.state.formFunkcio) {
      let obj = this.state.formFunkcio.rendelescikkbeans.find(rc => rc.cikkid == cikkObj.cikkid);
      cikkObj.funkciotetelId = obj ? obj.id : null;
      cikkObj.funkciotetel = obj ? 'VEVOI_RENDELES_CIKK' : null;
    }
  }

  addCikk = (event, cikkObj) => {
    this.addRendelesFunkcioTetelId(cikkObj);
    this.setState({ cikkek: [...this.state.cikkek, cikkObj] , editobj: cikkObj}, () => this.toggleCikk());
  }

   editCikk = (event, cikkObj) => {
    // Funkciotétel átmásolása, ha nem változott a cikk, mert egyébként elveszne, mivel a Form nem tartalmazza a mezőt
    if (this.state.editobj && this.state.editobj.cikkid == cikkObj.cikkid) {
      cikkObj.funkciotetelId = this.state.editobj.funkciotetelId;
      cikkObj.funkciotetel = this.state.editobj.funkciotetel;
    } else {
      this.addRendelesFunkcioTetelId(cikkObj);
    }
    this.state.cikkek[this.state.cikkek.indexOf(this.state.editobj)] = cikkObj;
    this.setState({ cikkek: this.state.cikkek, editmode: false, editobj: cikkObj }, () => this.toggleCikk());
  }

  deleteCikk = (cikkobj) => {
    this.setState({deleteButtonLoading: true});
    const cikkek = this.state.cikkek.filter(cikk => cikk !== cikkobj);
    let formRaktar = (cikkek.length > 0 || this.isVisszaruMozgTipus()) ? this.state.formRaktar : { nev: '', id: null };
    this.setState({ formRaktar, cikkek }, () => this.toggleTorles());
    this.setState({deleteButtonLoading: false});
  }

  handleDateInputChange = (e, v, name) => {
    if (name == 'formMozgasDatum' && !e)
      e = new Date();
    if(this.selected) {
      this.selected = false;
      switch (name) {
        case 'formMozgasDatum':
          e = moment(e).startOf('day');
          break;
      }
    }
    this.setState({
      [name]: e
    });
  }

  handleVisszaruChange = (v, edit) => {
    this.setState({ formElozmenyKeszlet: v, formCikkVisszList: [] });
    if (!edit)
      this.setState({ cikkek: [] });
    if (v) {
      this.setState({ formRaktar: v.raktar });
      Service.listKeszletCikkVisszaru(v.id, this.state.csokkenes?.id, false, (err, res) => {
        if (!err) {
          this.setState({ formCikkVisszList: res[0] });
          let cikkek = [...this.state.cikkek];
          cikkek.forEach(cikk => {
            if (!cikk.visszaru)
              cikk.cikkVisszaru = res[0].find(cikkVissz => cikkVissz.id == cikk.cikkVisszaru.id);
          });
          this.setState({ cikkek });
        }
      });
    }
  }

  handleInputChange = (e) => {
    const { target } = e;
    const { name } = target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.setState({
      [name]: value
    });
  }

  handlePartnerChange = (v) => {
    this.setState({ formPartner: v, formFunkcio: null });
    if (v && this.state.hasRendelesModule) {
      Service.listRendelesCsokkenes(v.id, null, (err, res) => {
        if (!err) {
          this.setState({ funkcioOptions: res[0] });
        }
      });
    } else {
      this.setState({ formFunkcio: null });
    }
  }

  isMozgasTipusEquals = (mozgasTipus) => {
    return this.state.formMozgasTipus && this.state.formMozgasTipus.id === mozgasTipus;
  }

  cikkIconFormatter = (cell, row) => {
    return (
      <div>
        <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditCikkClick(cell, row)} />
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={0}>Módosítás</UncontrolledTooltip>
        <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleDeleteCikkClick(row)} />
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'torles'} delay={0}>Törles</UncontrolledTooltip>
      </div>
    );
  }

  isVisszaruMozgTipus = () => {
    return this.state.formMozgasTipus && this.state.formMozgasTipus.id == 'VISS_C';
  }

  renderCikkTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };
  
    const columns = [
      {
        dataField: 'cikk.cikkszam',
        text: 'Cikkszám',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line',
          textAlign: 'right' 
        },
        sort: true
      },
      {
        dataField: 'cikk.megnevezes',
        text: 'Megnevezés',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line',
          textAlign: 'right' 
        },
        sort: true
      },
      {
        dataField: 'mennyiseg',
        text: 'Mennyiség',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: NumberFormatter.styleTextAlignWhiteSpace,
        formatter: (cell, row) => NumberFormatter.formatterSpaceOsszeg(cell) + (row && row.cikk ? ' ' + row.cikk.mennyisegiEgyseg : ''),
        sort: true
      },
      {
        dataField: 'cikk.id',
        text: 'Műveletek',
        align: 'center',
        headerStyle: { textAlign: 'center' },
        formatter: this.cikkIconFormatter
      }
    ];
    return (
      <React.Fragment>
        <Button className="table-new-button" type="button" color="success" disabled={this.isVisszaruMozgTipus() && !this.state.formElozmenyKeszlet} onClick={this.handleNewCikkClick}>Cikk kiválasztása</Button>
        <div className="animated fadeIn">
          <BootstrapTable
            bootstrap4
            keyField="cikk.id"
            data={this.state.cikkek}
            columns={columns}
            filter={filterFactory()}
            pagination={paginationFactory(Lib.bootstraptableProps)}
            noDataIndication="Nincs megjelenítendő adat!"
          />
        </div>
      </React.Fragment>
    );
  }

  renderRendelesCikkTable = () => {
    const handleRowSelect = (row, isSelect) => {
      this.setState((previousState) => {
        let array = previousState.rendelesCikkSelected;
        if (isSelect) {
          array.push(row.id);
        } else {
          array = array.filter(id => id != row.id);
        }
        return { rendelesCikkSelected: array };
      });
    };

    const handleRowSelectAll = (isSelect, rows) => {
      this.setState((previousState) => {
        let array = previousState.rendelesCikkSelected;
        if (isSelect) {
          array = rows.map(cikk => cikk.id);
        } else {
          array = [];
        }
        return { rendelesCikkSelected: array };
      });
    };

    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const selectRow = {
      mode: 'checkbox',
      clickToSelect: true,
      selected: this.state.rendelesCikkSelected,
      onSelect: handleRowSelect,
      onSelectAll: handleRowSelectAll
    };

    const filterCikkek = (list) => {
      if (!list) {
        return [];
      }
      const funkciotetelIdList = this.state.cikkek.map(c => c.funkciotetelId);
      return list.filter(rc => !funkciotetelIdList.includes(rc.id));
    };

    const columns = [
      {
        dataField: 'cikk',
        text: 'Cikk megnevezése (Cikkszám)',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line',
          textAlign: 'right'
        },
        sort: true,
        formatter: (cell) => {
          return cell.megnevezes + ' (' + cell.cikkszam + ')';
        }
      },
      {
        dataField: 'mennyiseg',
        text: 'Mennyiség\n(fennmaradó)',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        headerStyle: { whiteSpace: 'pre-line' },
        style: NumberFormatter.styleTextAlignWhiteSpace,
        formatter: (cell, row) => NumberFormatter.formatterSpaceOsszeg(cell) + ' ' + row.cikk.mennyisegiEgyseg,
        sort: true
      }
    ];
    return (
      <BootstrapTable
        bootstrap4
        keyField="id"
        data={filterCikkek(this.state.formFunkcio && this.state.formFunkcio.rendelescikkbeans)}
        columns={columns}
        filter={filterFactory()}
        pagination={paginationFactory(Lib.bootstraptableProps)}
        selectRow={selectRow}
      />
    );
  }
  renderForm = () => {
    return (
      <React.Fragment>
        <div className="row" style={STYLE_ROW}>
          <div className="col-md-4">
            <SelectField
              variant='async'
              label='Raktár:'
              name="formRaktar"
              id="formRaktar"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => this.setState({ formRaktar: v })}
              loadOptions={_.debounce(this.loadRaktarOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={this.state.formRaktar}
              defaultOptions
              isClearable
              required
              isDisabled={this.isVisszaruMozgTipus()}
            />
          </div>
          <div className="col-md-4">
            <DatetimePicker
              time
              label={`Mozgás dátuma:`}
              name="formMozgasDatum"
              value={this.state.formMozgasDatum && new Date(this.state.formMozgasDatum)}
              onChange={(e, v) => this.handleDateInputChange(e, v, 'formMozgasDatum')}
              onSelect={() => { this.selected = true }}
              max={new Date()}
              required
              timePrecision="seconds"
            />
          </div>
        </div>
        {!this.isMozgasTipusEquals('LELTAR_HIANY') && !this.isMozgasTipusEquals('VISS_C')
          && (
          <div style={STYLE_ROW}>
            <div className='row align-items-center'>
            <div className='col-md-4 form-group' >
              <SelectField
                variant='async'
                label='Vevő partner:'
                name="partnerId"
                id="partnerId"
                placeholder="Kezdj el gépelni a kereséshez..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                searchPromptText="Kezdj el gépelni a kereséshez..."
                loadingMessage={() => 'Keresés...'}
                onChange={this.handlePartnerChange}
                loadOptions={_.debounce(this.loadPartnerOptions, 1000)}
                value={this.state.formPartner}
                getOptionValue={option => option.id}
                getOptionLabel={option => option.nev}
                defaultOptions
                isClearable
                />
              </div>
              {this.state.hasRendelesModule
                  && (
                    <>
                      <div className="col-md-4" style={{ marginTop: 10 }}>
                        <Input
                          type="select"
                          name="formFunkcioNev"
                          value={this.state.formFunkcioNev}
                          onChange={this.handleInputChange}
                          disabled={!this.state.formPartner}
                        >
                          <option value="VEVOI_RENDELES">Vevői rendelés</option>
                        </Input>
                      </div>
                      <div className="col-md-4" style={{ marginTop: 10 }}>
                        <SelectField
                          name="funkcioId"
                          id="funkcioId"
                          placeholder="Kezdj el gépelni a kereséshez..."
                          noOptionsMessage={() => 'Nincs keresési eredmény'}
                          searchPromptText="Kezdj el gépelni a kereséshez..."
                          loadingMessage={() => 'Keresés...'}
                          onChange={v => this.setState({ formFunkcio: v })}
                          options={this.state.funkcioOptions}
                          value={this.state.formFunkcio}
                          getOptionValue={option => option.id}
                          getOptionLabel={option => option && option.bizonylatBean && option.bizonylatBean.bizonylatszam}
                          isDisabled={!this.state.formPartner || this.state.cikkek.length !== 0}
                          isClearable
                        />
                      </div>
                    </>
                  )
                }
              </div>
              {this.state.hasRendelesModule
                && (
                  <div className="row">
                    <div className="col-md-2">
                      <Button
                        type="button"
                        color="primary"
                        hidden={!this.state.formFunkcio || this.state.formFunkcioNev !== 'VEVOI_RENDELES'}
                        onClick={this.toggleRendelesCikk}
                      >
                        Rendelés aktív tételei
                      </Button>
                    </div>
                  </div>
                )
              }
            </div>
          )
        }
        <div className="row" style={STYLE_ROW}>
          {this.isMozgasTipusEquals('ERTE') && (
            <>
              <div className="col-md-4">
                <SelectField
                  variant='async'
                  label='Fizetési mód:'
                  name="formFizmod"
                  id="formFizmod"
                  placeholder="Kezdj el gépelni..."
                  noOptionsMessage={() => 'Nincs keresési eredmény'}
                  onChange={v => this.setState({ formFizmod: v })}
                  loadOptions={_.debounce(this.loadFizmodOptions, 1000)}
                  getOptionLabel={option => option.nev}
                  getOptionValue={option => option.id}
                  value={this.state.formFizmod}
                  defaultOptions
                  isClearable
                />
              </div>
              <div className="col-md-4">
                <DatePicker 
                  label={'Fizetési határidő:'}
                  name="formFizetesihatarido"
                  value={this.state.formFizetesihatarido ? new Date(this.state.formFizetesihatarido) : null}
                  onChange={(e, v) => this.handleDateInputChange(e, v, 'formFizetesihatarido')}
                />
              </div>
            </>
          )}
          {this.isMozgasTipusEquals('FELH') && (
            <div className="col-md-4">
              <RFField
                label="Munkalap száma:"
                name="formMunkalapszam" 
                value={this.state.formMunkalapszam} 
                onChange={this.handleInputChange}
              />
            </div>
          )}
          {this.isVisszaruMozgTipus() && <div className='col-md-4'>
            <RFField
              label='Partner:'
              name="formPartnerVissz"
              id="formPartnerVissz"
              value={this.state.formElozmenyKeszlet && this.state.formElozmenyKeszlet.partner && this.state.formElozmenyKeszlet.partner.nev}
              disabled
            />
          </div>}
          <div className="col-md-4">
            <RFField
              label="Megjegyzés:"
              name="formMegjegyzes" 
              value={this.state.formMegjegyzes}
              onChange={this.handleInputChange} 
            />
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderModals = () => {
    return (
      <React.Fragment>
        <Modal isOpen={this.state.modalTorles} toggle={this.toggleTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
          <ProgressButton loading={this.state.deleteButtonLoading} className="btn-cursor-pointer" color="primary" onClick={() => this.deleteCikk(this._currentDeleteObj)}>OK</ProgressButton>
            <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalAccept} toggle={this.toggleAccept} className={this.props.className} backdrop="static">
          <ModalHeader>Mentés és véglegesítés</ModalHeader>
          <ModalBody>„Mentés és véglegesítés" után az adott tétel nem módosítható, törölhető, csak stornózható! Valóban elfogadja rögzített adatok mentését?</ModalBody>
          <ModalFooter>
            <ProgressButton loading={this.state.mentesLoadingButton} className="btn-cursor-pointer" color="primary" id="save-and-close" onClick={() => this.save(null, this._currentAcceptObj)}>OK</ProgressButton>
            <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleAccept}>Mégsem</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalRendelesCikk} toggle={this.toggleRendelesCikk} className={this.props.className} backdrop="static">
          <ModalHeader>Cikkek választása</ModalHeader>
          <ModalBody>
            {this.renderRendelesCikkTable()}
          </ModalBody>
          <ModalFooter>
            <Button className="btn-cursor-pointer" type="button" color="primary" onClick={this.handleRendelesCikkSubmit}>Kiválasztás</Button>
            <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleRendelesCikk}>Mégsem</Button>
          </ModalFooter>
        </Modal>

        <CikkSelect
          isOpen={this.state.modalCikk}
          toggle={this.toggleCikk}
          add={this.addCikk}
          cikkek={this.state.cikkek}
          editmode={this.state.editmode}
          editobj={this.state.editobj}
          edit={this.editCikk}
          mozgasTipus={this.state.formMozgasTipus}
          raktar={this.state.formRaktar}
          formKeszletInfoRaktarak={this.state.formKeszletInfoRaktarak}
          formKeszletLoadingStatus={this.state.formKeszletLoadingStatus}
          getData={this.loadKeszletInfo}
          handleListItemClick={this.handleListItemClick}
          selectedCikkId={this.state.selectedCikkId}
          changeCikkId={cikkid => this.setState({ selectedCikkId: cikkid })}
          price={false}
          keszletinfo
          globals={this.props.globals}
          selectedSzabad={this.state.szabadMennyiseg}
          onSave={this.onSaveKeszletInfo}
          visszaru={this.isVisszaruMozgTipus()}
          cikkekVisszaru={this.state.formCikkVisszList}
        />
      </React.Fragment>
    );
  }

  renderButtons = () => {
    return (
      <div className="top-15-margin">
        <ProgressButton color="primary" id="save" loading={this.state.mentesLoadingButton}>Mentés</ProgressButton>
        {' '}
        <ProgressButton color="primary" id="save-and-close" loading={this.state.mentesLoadingButton}>Mentés és véglegesítés</ProgressButton>
        {' '}
        <Button type="button" color="secondary" onClick={this.handleBackClick}>Mégsem</Button>
      </div>
    );
  }

  render() {
    return (
      <div>
        <RFForm onSubmit={this.save}>
          <div className="row" style={STYLE_ROW}>
            <div className="col-md-4">
              <SelectField
                variant='async'
                label='Mozgástípus:'
                name="formMozgastipus"
                id="formMozgastipus"
                placeholder="Kezdj el gépelni..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                onChange={v => this.setState({ formMozgasTipus: v, formCikkVisszList: [] })}
                loadOptions={_.debounce(this.loadMozgasTipusOptions, 1000)}
                getOptionLabel={option => option.name}
                getOptionValue={option => option.id}
                value={this.state.formMozgasTipus}
                isDisabled={!!this.state.csokkenes.id}
                defaultOptions
                isClearable
                />
            </div>
            {this.isVisszaruMozgTipus() && <div className='col-md-4'>
              <SelectField
                variant='async'
                label='Előzmény bizonylatszám:'
                name="formElozmenyKeszlet"
                id="formElozmenyKeszlet"
                placeholder="Kezdj el gépelni..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                onChange={this.handleVisszaruChange}
                loadOptions={_.debounce(this.loadVisszaruBevetelezes, 1000)}
                getOptionLabel={option => option.bizonylatszam}
                getOptionValue={option => option.id}
                value={this.state.formElozmenyKeszlet}
                isClearable
                required
              />
            </div>}
          </div>
          {this.state.formMozgasTipus && this.renderForm()}
          {this.state.formMozgasTipus && this.renderCikkTable()}
          {this.renderButtons()}
        </RFForm>
        {this.renderModals()}
      </div>
    );
  }
}

export default KeszletcsokkenesForm;
